import React, { useEffect } from 'react';
import { string, bool, func, arrayOf } from 'prop-types';
import styled from 'styled-components';
import ImagePlaceholder from '@bbc/psammead-image-placeholder';
import Message from '../Message'; // XSS protection to ensure we only react to events sent from recognised origins

var isValidEvent = function isValidEvent(_ref, acceptableEventOrigins) {
  var origin = _ref.origin;
  return RegExp("^https?://(".concat(acceptableEventOrigins.join('|'), ")(:|/|$)"), 'i').test(origin);
};

var Canonical = function Canonical(_ref2) {
  var src = _ref2.src,
      placeholderSrcset = _ref2.placeholderSrcset,
      title = _ref2.title,
      placeholderSrc = _ref2.placeholderSrc,
      service = _ref2.service,
      noJsMessage = _ref2.noJsMessage,
      showPlaceholder = _ref2.showPlaceholder,
      showLoadingImage = _ref2.showLoadingImage,
      darkMode = _ref2.darkMode,
      onMediaInitialised = _ref2.onMediaInitialised,
      onMediaPlaying = _ref2.onMediaPlaying,
      onMediaPause = _ref2.onMediaPause,
      onMediaEnded = _ref2.onMediaEnded,
      onMediaPlaylistEnded = _ref2.onMediaPlaylistEnded,
      onMediaError = _ref2.onMediaError,
      acceptableEventOrigins = _ref2.acceptableEventOrigins;
  var backgroundStyle = "\n    background-image: url(".concat(placeholderSrc, ");\n    background-repeat: no-repeat;\n    background-size: contain;\n  ");
  var LoadingImageWrapper = /*#__PURE__*/styled.div.withConfig({
    displayName: "LoadingImageWrapper",
    componentId: "fuo2ed-0"
  })(["position:absolute;left:0;top:0;width:100%;height:100%;"]);
  var StyledIframe = /*#__PURE__*/styled.iframe.withConfig({
    displayName: "StyledIframe",
    componentId: "fuo2ed-1"
  })(["", ";border:0;left:0;overflow:hidden;position:absolute;top:0;width:100%;height:100%;", ""], showLoadingImage ? "z-index: 1" : '', showPlaceholder ? backgroundStyle : null);
  useEffect(function () {
    var handler = function handler(e) {
      if (!isValidEvent(e, acceptableEventOrigins)) return;
      var callback = {
        mediaInitialised: onMediaInitialised,
        mediaPlaying: onMediaPlaying,
        mediaPause: onMediaPause,
        mediaEnded: onMediaEnded,
        mediaPlaylistEnded: onMediaPlaylistEnded,
        mediaError: onMediaError
      }[e.data.event];
      if (callback) callback(e);
    };

    window.addEventListener('message', handler);
    return function () {
      return window.removeEventListener('message', handler);
    };
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(StyledIframe, {
    src: src,
    title: title,
    allow: "autoplay; fullscreen",
    scrolling: "no",
    gesture: "media",
    allowFullScreen: true
  }), showLoadingImage && /*#__PURE__*/React.createElement(LoadingImageWrapper, null, /*#__PURE__*/React.createElement(ImagePlaceholder, {
    ratio: 56.25,
    darkMode: darkMode
  })), /*#__PURE__*/React.createElement("noscript", null, /*#__PURE__*/React.createElement(Message, {
    service: service,
    message: noJsMessage,
    placeholderSrc: placeholderSrc,
    placeholderSrcset: placeholderSrcset
  })));
};

Canonical.propTypes = {
  src: string.isRequired,
  placeholderSrcset: string,
  title: string.isRequired,
  placeholderSrc: string,
  service: string.isRequired,
  noJsMessage: string.isRequired,
  showPlaceholder: bool.isRequired,
  showLoadingImage: bool.isRequired,
  darkMode: bool.isRequired,
  onMediaInitialised: func.isRequired,
  onMediaPlaying: func.isRequired,
  onMediaPause: func.isRequired,
  onMediaEnded: func.isRequired,
  onMediaPlaylistEnded: func.isRequired,
  onMediaError: func.isRequired,
  acceptableEventOrigins: arrayOf(string)
};
Canonical.defaultProps = {
  placeholderSrc: null,
  placeholderSrcset: '',
  acceptableEventOrigins: ['www.test.bbc.com', 'polling.test.bbc.com', 'www.bbc.com', 'polling.bbc.com', 'localhost.bbc.com', 'localhost']
};
export default Canonical;